import React, {InputHTMLAttributes} from "react";
import styles from "./RadioButton.module.scss";
import {isTouchDevice} from "../../../../helpers/deviceInformation";

type RadioButtonProps = {
  size?: number;
  color?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const RadioButton: React.FC<RadioButtonProps> = ({
  children,
  checked,
  onChange,
  className = "",
  name,
  value,
  color = "#0db700",
  size = 2,
}) => {
  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        <input type={"radio"} name={name} value={value} checked={checked} onChange={onChange} />
        <div
          className={`${styles.radioWrapper} ${className}`}
          style={{width: `${size * 10}px`, height: `${size * 10}px`}}
        >
          {checked && <div className={`${styles.radio}`} style={{backgroundColor: color}} />}
          {!checked && !isTouchDevice() && <div className={`${styles.radioUnchecked}`} />}
        </div>
        {children}
      </label>
    </div>
  );
};

export default RadioButton;
